import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => (
  <>
    <Helmet>
      <title>404 Not Found | nautdigital</title>
      <meta name="description" content="Sorry, the page you are looking for does not exist." />
    </Helmet>
    <div className="min-h-screen flex flex-col items-center justify-center bg-transparent text-center px-4">
      <h1 className="text-7xl font-bold text-accent mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Page Not Found</h2>
      <p className="text-gray-400 mb-8">Sorry, the page you are looking for does not exist.</p>
      <Link to="/" className="btn btn-primary px-8 py-3 text-lg">Go Home</Link>
    </div>
  </>
);

export default NotFound; 